
import { TextAlignProperty } from "csstype";
import {
  defineComponent,
  nextTick,
  onMounted,
  ref,
  toRefs,
  computed,
  PropType,
} from "vue";
import BaseFormInlineEntry from "../base-form-inline-entry/base-form-inline-entry.vue";
import BaseTypography from "../base-typography/base-typography.vue";

export default defineComponent({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: "",
    },
    staticLabel: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String as PropType<string | null | number>,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    textAlign: {
      type: String as PropType<TextAlignProperty>,
      default: "left",
    },
    autoFocusOnMount: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
  },
  components: { BaseFormInlineEntry, BaseTypography },
  setup(props, context) {
    const { autoFocusOnMount, staticLabel, label } = toRefs(props);
    const isInputAutoFilledByBrowser = ref(false);
    const avaInput = ref<HTMLInputElement>();

    const detectAutofill = (element?: Element): boolean => {
      if (!element) return false;
      const appearanceValue = window
        .getComputedStyle(element, null)
        .getPropertyValue("appearance");
      return appearanceValue === "menulist-button";
    };
    const setIsInputAutoFilledByBrowser = () => {
      isInputAutoFilledByBrowser.value = detectAutofill(avaInput.value);
    };
    const staticLabelComputed = computed(
      () =>
        staticLabel.value ||
        (isInputAutoFilledByBrowser.value ? label.value : "")
    );
    onMounted(() => {
      if (autoFocusOnMount.value) {
        nextTick(() => {
          (avaInput.value as HTMLInputElement).focus();
        });
      }
      setTimeout(setIsInputAutoFilledByBrowser, 1000);
    });
    return {
      avaInput,
      setIsInputAutoFilledByBrowser,
      isInputAutoFilledByBrowser,
      staticLabelComputed,
      updateModelValue: (event: unknown) => {
        // @ts-ignore
        context.emit("update:modelValue", event.target.value);
      },
    };
  },
});
